<template>
  <div class="ba-root ba-root--vertical">

    <!-- ═══ TOPO: Header + Acoes ═══ -->
    <div class="ba-top-bar">
      <div class="ba-header">
        <div class="ba-header-icon">
          <svg-lampada />
        </div>
        <div class="ba-header-text">
          <div class="ba-header-title">Botoes de Acao</div>
          <div class="ba-header-sub">CTA em momentos do video</div>
        </div>
      </div>
      <div class="ba-top-actions">
        <button v-if="isGetSaveCallActions" class="ba-btn-save" @click="salvar()">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M5 13l4 4L19 7" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
          Salvar
        </button>
        <router-link :to="`/player/${vslId}/customizacao`" class="ba-btn-back">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M19 12H5M12 19l-7-7 7-7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
          Voltar
        </router-link>
      </div>
    </div>

    <!-- ═══ PLAYER PREVIEW (iframe real) ═══ -->
    <div class="ba-player-section">
      <player-preview-iframe
        v-if="vslId"
        :vsl-id="vslId"
        :thumb-src="dadosVideo && dadosVideo.thumb ? dadosVideo.thumb.thumbStart : ''"
      />
    </div>

    <!-- ═══ BOTOES DE ACAO (abaixo do player) ═══ -->
    <div class="ba-controls-section">

      <!-- Botao adicionar -->
      <button class="ba-btn-add" @click="showModalAddCallAction">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M12 5v14M5 12h14" stroke="#E86A10" stroke-width="2.5" stroke-linecap="round"/></svg>
        Adicionar novo botao
      </button>

      <!-- Lista de CTAs -->
      <div v-if="callActions && callActions.length > 0" class="ba-cta-list">
        <call-action-item
          v-for="(item, index) in callActions"
          :key="index"
          :value="item"
          @editar="showModalEdit(item)"
          @deleted="showModalDelete(item)"
        />
      </div>

      <!-- Empty state -->
      <div v-else class="ba-empty-state">
        <div class="ba-empty-icon">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
            <rect x="3" y="8" width="18" height="8" rx="4" stroke="#DDE3EA" stroke-width="1.5"/>
            <path d="M8 12h.01M12 12h.01M16 12h.01" stroke="#DDE3EA" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </div>
        <p class="ba-empty-title">Nenhum botao adicionado</p>
        <span class="ba-empty-sub">Clique em "Adicionar novo botao" para criar seu primeiro CTA.</span>
      </div>

    </div>

    <modal-add-botao />

    <modal-confirmation
      id-modal="call-actions"
      title="Excluir Ação"
      @okDeleteFluxoChat="deletedCallAction"
    >
      <template #content-message>
        <p>Tem certeza que deseja excluir esta ação?</p>
      </template>
    </modal-confirmation>

  </div>
</template>

<script>

import axios from 'axios'
import { ThumbNailsService } from '@/services/Thumbnails'
import { ControlsService } from '@/services/Controls'
import SvgLampada from '@/views/App/Videos/Customizacao/Botoes-&-Acoes/svgs/SvgLampada.vue'
import {
  VBModal,
  VBTooltip,
  BProgressBar,
} from 'bootstrap-vue'
import ModalAddBotao from '@/views/App/Videos/Customizacao/Botoes-&-Acoes/modal-add-botoes/ModalAddBotao.vue'
import CallActionItem from '@/views/App/Videos/Customizacao/Botoes-&-Acoes/CallActionItem.vue'
import PlayerPreviewIframe from '@/components/player/PlayerPreviewIframe.vue'
import { mapActions } from 'vuex'
import ModalConfirmation from '@/components/ModalConfirmation.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { convertSecondsToTime, convertTimeToSeconds } from '@/@core/utils/utils'

export default {
  components: {
    ModalConfirmation,
    CallActionItem,
    ModalAddBotao,
    SvgLampada,
    BProgressBar,
    PlayerPreviewIframe,
  },
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend',
      VUE_APP_HOST_API_AWS_S3: process.env.VUE_APP_HOST_API_AWS_S3 || '/api/dkbucket',
      userData: JSON.parse(localStorage.getItem('userData')),
      vslId: this.$route.params.vslId,
      errorMessage: null,
      loading: false,
      valid: '',
      validPausa: '',
      validFinal: '',
      imageUrlInicio: '',
      imageUrlPausa: '',
      imageUrlEnd: '',
      dialogImageUrl: '',
      dialogVisible: false,
      uploadPercentage: 0,
      urlImagem: '',
      key_name: '',
      urlImagemPausa: '',
      key_namePausa: '',
      urlImagemFinal: '',
      key_nameFinal: '',
      Thumb: [],
      files: [],
      filesPausa: [],
      filesFinal: [],
      playx: 'true',
      control: [],
      dadosVideo: [],
      videoDuration: 99999,
      progress: 0,
      timeAtualPregress: '',
    }
  },
  computed: {
    isGetSaveCallActions() {
      return this.$store.getters['callActions/isSave']
    },
    getControls() {
      return this.control
    },
    getVideoSetting() {
      return this.dadosVideo
    },
    callActions: {
      get() {
        return this.$store.getters['callActions/allCallActions']
      },
      set(value) {
        this.$store.commit('callActions/SET_ALL_CALL_ACTIONS', value)
      },
    },
    progressAtual() {
      return this.progress
    },
  },
  watch: {
    callActions(value) {
      if (value) {
        this.removerCallActionsVsl()
      }
    },
    progress(value) {
      if (value) {
        this.timeAtualPregress = this.formatTimeProgress()
      }
    },
  },
  async created() {
    try {
      const response = await ThumbNailsService.getALLThumbnails()
      this.Thumb = response.data
      const controle = await ControlsService.getControlVSL_Id(this.vslId)
      this.control = controle.data
      this.loading = false
    } catch (error) {
      this.errorMessage = error
      this.loading = false
    }
  },
  beforeMount() {
    this.jsonPersonalizado()
  },
  beforeDestroy() {
    this.$store.commit('callActions/CLEAR_SAVE_OFF')
  },
  mounted() {
    this.listar()
    this.createStyle(this.vslId)
    this.$store.dispatch('callActions/fetchCallActions', this.vslId)
    this.UploadImgFinal()
    this.UploadImgPausa()
    this.UploadImg()
  },
  methods: {
    ...mapActions('callActions', ['fetchCallActions']),
    toggleMutedAudio() {
      const player = document.querySelector('.player')
      const video = player.querySelector('.player_my_video')
      video.muted = !video.muted
    },
    formatTimeProgress() {
      const video = document.getElementById('mainVideo')
      const formatDigits = value => (value < 10 ? `0${value}` : value)
      const currentMinutes = Math.floor(video.currentTime / 60)
      const currentSeconds = Math.floor(video.currentTime % 60)
      const durationMinutes = Math.floor(video.duration / 60)
      const durationSeconds = Math.floor(video.duration % 60)
      const formattedCurrentTime = `${formatDigits(currentMinutes)}:${formatDigits(currentSeconds)}`
      const formattedDuration = `${formatDigits(durationMinutes)}:${formatDigits(durationSeconds)}`
      return `${formattedCurrentTime} / ${formattedDuration}`
    },
    showModalAddCallAction() {
      this.$bvModal.show('modal-add-botoes')
      this.$store.commit('Videos/setVideoEditAtual', {
        id_vsl: this.vslId,
        duration: this.videoDuration,
      })
      this.$store.commit('callActions/SET_ID_VLS', this.vslId)
    },
    async showModalEdit(callAction) {
      this.$bvModal.show('modal-add-botoes')
      this.$store.commit('Videos/setVideoEditAtual', {
        id_vsl: this.vslId,
        duration: this.videoDuration,
      })
      callAction = {
        ...callAction,
        start: convertSecondsToTime(callAction.start),
        end: convertSecondsToTime(callAction.end),
      }
      await this.$store.commit('callActions/SET_CALL_ACTION', callAction)
    },
    async showModalDelete(callAction) {
      this.$bvModal.show('modal-delete-call-actions')
      await this.$store.commit('callActions/SET_CALL_ACTION', callAction)
    },
    async deletedCallAction() {
      this.removerCallActionsVsl()
      await this.$store.dispatch('callActions/deletedCallAction')
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Sucesso',
              text: 'Ação excluída com sucesso',
              icon: 'AlertTriangleIcon',
              variant: 'success',
            },
          })
          this.carregarCallActionsVsl()
        })
      this.$bvModal.hide('modal-delete-call-actions')
    },
    formatTime(time) {
      let seconds = Math.floor(time % 60)
      let minutes = Math.floor(time / 60) % 60
      let hours = Math.floor(time / 3600)
      seconds = seconds < 10 ? `0${seconds}` : seconds
      minutes = minutes < 10 ? `0${minutes}` : minutes
      hours = hours < 10 ? `0${hours}` : hours
      if (hours == 0) return `${minutes}:${seconds}`
      return `${hours}:${minutes}:${seconds}`
    },
    jsonPersonalizado() {
      const url = `${this.VUE_APP_HOST_API_BACKEND}/vslsInner/${this.vslId}`
      fetch(url)
        .then(response => response.json())
        .then(data => {
          if (data.status == '1') {
            this.dadosVideo = data.json.find(item => String(item.id) === String(this.vslId))
            if (this.dadosVideo && this.dadosVideo.vsl_duration) {
              this.videoDuration = parseInt(this.dadosVideo.vsl_duration)
            }
          }
        })
    },
    togglePlay() {
      const player = document.querySelector('.player')
      const video = player.querySelector('.player_my_video')
      const togglePausePlay = document.querySelector('.player-video-vsl .playpause')
      const togglePausePlaybg = player.querySelector('.playpausebg')
      const toggleEndedbg = player.querySelector('.playEndedbg')
      const iniciar = player.querySelector('#msg-inicial-player')
      iniciar.classList.add('vslbooster-controlls__hide')
      if (video.ended) {
        toggleEndedbg.setAttribute('hidden', '')
      }
      if (video.paused) {
        this.carregarCallActionsVsl()
        video.play()
        togglePausePlay.removeAttribute('hidden')
        togglePausePlaybg.removeAttribute('hidden')
        video.muted = false
      } else if (this.playx === true) {
        iniciar.classList.add('vslbooster-controlls__hide')
        video.muted = false
        video.load()
        this.playx = false
      } else {
        video.pause()
        togglePausePlay.removeAttribute('hidden')
        togglePausePlaybg.removeAttribute('hidden')
      }
    },
    avancar() {
      const player = document.querySelector('.player')
      const video = player.querySelector('.player_my_video')
      video.currentTime += 10
    },
    retroceder() {
      const player = document.querySelector('.player')
      const video = player.querySelector('.player_my_video')
      video.currentTime -= 10
    },
    toggleFullScreen() {
      const player = document.querySelector('.player')
      if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullScreenElement && !document.msFullScreenElement) {
        if (player.requestFullscreen) player.requestFullscreen()
        else if (player.msRequestFullscreen) player.msRequestFullScreen()
        else if (player.mozRequestFullScreen) player.mozRequestFullScreen()
        else if (player.webkitRequestFullscreen) player.webkitRequestFullscreen()
      } else if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    },
    updateButton() {
      const player = document.querySelector('.player')
      const toggle = player.querySelector('.toggle')
      const icon = this.paused ? '▶' : '❚❚'
      toggle.textContent = icon
    },
    handleProgress(e) {
      let percentReal
      const player = document.querySelector('.player')
      const video = player.querySelector('.player_my_video')
      const progressBar = player.querySelector('.progress_my_filled')
      const togglePausePlay = player.querySelector('.playpause')
      const toggleEndedbg = player.querySelector('.playEndedbg')
      const { currentTime, duration } = e.target
      const percent = (currentTime / duration) * 100
      progressBar.style.width = `${percent}%`
      if (this.$refs.mainVideo.ended) {
        toggleEndedbg.removeAttribute('hidden')
        togglePausePlay.removeAttribute('hidden')
      }
      const percentFake = (this.$refs.mainVideo.currentTime / 150) * 100
      if (percentFake <= 50) {
        percentReal = (this.$refs.mainVideo.currentTime / 150) * 100
        progressBar.style.flexBasis = `${percentFake}%`
      } else {
        progressBar.style.flexBasis = `${percentReal}%`
      }
    },
    async salvar() {
      const pending = this.$store.getters['callActions/GET_CALL_ACTION_OFF_SAVE']
      const toCreate = []
      const toUpdate = []

      pending.forEach(c => {
        const item = {
          ...c,
          start: typeof c.start === 'string' ? convertTimeToSeconds(c.start) : c.start,
          end: c.end === 'Infinito' || c.end === null || c.end === '' ? null : (typeof c.end === 'string' ? convertTimeToSeconds(c.end) : c.end),
        }
        if (item.id) {
          toUpdate.push(item)
        } else {
          toCreate.push(item)
        }
      })

      // Cria novos
      if (toCreate.length) {
        this.$store.commit('callActions/SET_CONVERT_TIME_END_START', toCreate)
        await this.$store.dispatch('callActions/createVariosCallActions', this.videoDuration)
      }

      // Atualiza existentes
      for (const item of toUpdate) {
        try {
          await this.$http.put(`${this.VUE_APP_HOST_API_BACKEND}/call-actions/${item.id}`, item)
        } catch (e) {
          console.error('[VSLBooster] Erro ao atualizar CTA:', e)
        }
      }

      // Limpa e recarrega
      this.$store.commit('callActions/CLEAR_SAVE_OFF')
      await this.$store.dispatch('callActions/fetchCallActions', this.vslId)
      this.removerCallActionsVsl()
      this.$nextTick(() => {
        const iframe = document.querySelector('.dk-ppi-frame')
        if (iframe) iframe.src = iframe.src
      })
    },
    listar() {
      ThumbNailsService.getThumbnailVSL_Id(this.vslId).then(resposta => {
        this.Thumb = resposta.data
        this.valid = (this.Thumb[0].tumb_start.length >= 1)
        this.validPausa = (this.Thumb[0].tumb_pausa.length >= 1)
        this.validFinal = (this.Thumb[0].tumb_end.length >= 1)
        this.imageUrlInicio = (this.Thumb[0].tumb_start)
        this.imageUrlPausa = (this.Thumb[0].tumb_pausa)
        this.imageUrlEnd = this.Thumb[0].tumb_end
      })
    },
    enviarArquivo() {
      const formData = new FormData()
      formData.append('video', this.files)
      formData.append('caminho', `${this.userData.user_file_key}UploadImageThumb/Thumbnail_inicio/`)
      axios.post(`${this.VUE_APP_HOST_API_AWS_S3}/thumb`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100))
        }.bind(this),
      }).then(response => {
        this.urlImagem = response.data.data.fileUrl
        this.NameImagem = response.data.data.fileNameOrigin
        this.key_name = response.data.data.key_filename
        if (response.data.data.status == 201) this.updateSubmit()
      })
    },
    enviarArquivoPausa() {
      const formData = new FormData()
      formData.append('video', this.filesPausa)
      formData.append('caminho', `${this.userData.user_file_key}UploadImageThumb/Thumbnail_Pause/`)
      axios.post(`${this.VUE_APP_HOST_API_AWS_S3}/thumb`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100))
        }.bind(this),
      }).then(response => {
        this.urlImagemPausa = response.data.data.fileUrl
        this.NameImagemPausa = response.data.data.fileNameOrigin
        this.key_namePausa = response.data.data.key_filename
        if (response.data.data.status == 201) this.updateSubmitPausa()
      })
    },
    enviarArquivoFinal() {
      const formData = new FormData()
      formData.append('video', this.filesFinal)
      formData.append('caminho', `${this.userData.user_file_key}UploadImageThumb/Thumbnail_Final/`)
      axios.post(`${this.VUE_APP_HOST_API_AWS_S3}/thumb`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100))
        }.bind(this),
      }).then(response => {
        this.urlImagemFinal = response.data.data.fileUrl
        this.NameImagemFinal = response.data.data.fileNameOrigin
        this.key_nameFinal = response.data.data.key_filename
        if (response.data.data.status == 201) this.updateSubmitFinal()
      })
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    uploadImageUrl(e, classImage) {
      const pictureImage = document.querySelector(`.${classImage}`)
      const pictureImageTxt = ''
      if (classImage === 'picture__image') this.files = e.target.files[0]
      if (classImage === 'picture__imageUpload') this.filesPausa = e.target.files[0]
      if (classImage === 'pictureFinal') this.filesFinal = e.target.files[0]
      if (this.files) {
        const reader = new FileReader()
        reader.addEventListener('load', function (e) {
          const readerTarget = e.target
          const img = document.createElement('img')
          if (classImage === 'picture__image') this.imageUrlInicio = readerTarget.result
          if (classImage === 'picture__imageUpload') this.imageUrlPausa = readerTarget.result
          if (classImage === 'pictureFinal') this.imageUrlEnd = readerTarget.result
          img.src = readerTarget.result
          img.classList.add('picture__img')
          img.setAttribute('style', 'max-width:100%;')
          pictureImage.innerHTML = ''
          pictureImage.appendChild(img)
        })
        if (classImage === 'picture__image') reader.readAsDataURL(this.files)
        if (classImage === 'picture__imageUpload') reader.readAsDataURL(this.filesPausa)
        if (classImage === 'pictureFinal') reader.readAsDataURL(this.filesFinal)
      } else {
        pictureImage.innerHTML = pictureImageTxt
      }
    },
    UploadImg() {
      const inputFile = document.querySelector('#picture__input')
      const pictureImage = document.querySelector('.picture__image')
      if (!inputFile || !pictureImage) return
      pictureImage.innerHTML = ''
      inputFile.addEventListener('change', e => {
        const file = e.target.files[0]
        this.files = file
        if (file) {
          const reader = new FileReader()
          reader.addEventListener('load', e => {
            const img = document.createElement('img')
            img.src = e.target.result
            img.setAttribute('style', 'max-width:100%;')
            img.classList.add('picture__img')
            pictureImage.innerHTML = ''
            pictureImage.appendChild(img)
          })
          reader.readAsDataURL(file)
        } else {
          pictureImage.innerHTML = ''
        }
      })
    },
    UploadImgPausa() {
      const inputFile = document.querySelector('#Input_UploadPausa')
      const pictureImage = document.querySelector('.picture__imageUpload')
      if (!inputFile || !pictureImage) return
      pictureImage.innerHTML = ''
      inputFile.addEventListener('change', e => {
        const file = e.target.files[0]
        this.filesPausa = file
        if (file) {
          const reader = new FileReader()
          reader.addEventListener('load', e => {
            const img = document.createElement('img')
            img.src = e.target.result
            img.classList.add('picture__img')
            img.setAttribute('style', 'max-width:100%;')
            pictureImage.innerHTML = ''
            pictureImage.appendChild(img)
          })
          reader.readAsDataURL(file)
        } else {
          pictureImage.innerHTML = ''
        }
      })
    },
    UploadImgFinal() {
      const inputFile = document.querySelector('#Input_UploadFinal')
      const pictureImage = document.querySelector('.pictureFinal')
      if (!inputFile || !pictureImage) return
      pictureImage.innerHTML = ''
      inputFile.addEventListener('change', e => {
        const file = e.target.files[0]
        this.filesFinal = file
        if (file) {
          const reader = new FileReader()
          reader.addEventListener('load', e => {
            const img = document.createElement('img')
            img.src = e.target.result
            img.classList.add('picture__img')
            img.setAttribute('style', 'max-width:100%;')
            pictureImage.innerHTML = ''
            pictureImage.appendChild(img)
          })
          reader.readAsDataURL(file)
        } else {
          pictureImage.innerHTML = ''
        }
      })
    },
    updateSubmit() {
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/tumbinicio/${this.vslId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: `{"tumb_start":"${this.urlImagem}","tumb_key_name_start":"${this.key_name}","id_vsl":"${this.vslId}"}`,
      }).then(() => {
        this.listar()
        this.$message({ type: 'success', message: 'Salvo com sucesso' })
      })
    },
    updateSubmitPausa() {
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/tumbpausa/${this.vslId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: `{"tumb_pausa":"${this.urlImagemPausa}","thumb_key_name_pausa":"${this.key_namePausa}","id_vsl":"${this.vslId}"}`,
      }).then(() => {
        this.listar()
        this.$message({ type: 'success', message: 'Salvo com sucesso' })
      })
    },
    updateSubmitFinal() {
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/tumbfinal/${this.vslId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: `{"tumb_end":"${this.urlImagemFinal}","thumb_key_name_end":"${this.key_nameFinal}","id_vsl":"${this.vslId}"}`,
      }).then(() => {
        this.$message({ type: 'success', message: 'Salvo com sucesso' })
        this.listar()
      })
    },
    DeletThumb() {
      this.url = ''
      this.key = ''
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/tumbinicio/${this.vslId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: `{"tumb_start":"${this.url}","tumb_key_name_start":"${this.key}","id_vsl":"${this.vslId}"}`,
      }).then(response => { if (response.status == 200) { this.deletarAWS; this.listar() } })
    },
    DeletThumbPausa() {
      this.url = ''
      this.key = ''
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/tumbpausa/${this.vslId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: `{"tumb_pausa":"${this.url}","thumb_key_name_pausa":"${this.key}","id_vsl":"${this.vslId}"}`,
      }).then(response => { if (response.status == 200) { this.deletarAWS; this.listar() } })
    },
    DeletThumbFinal() {
      this.url = ''
      this.key = ''
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/tumbfinal/${this.vslId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: `{"tumb_end":"${this.url}","thumb_key_name_end":"${this.key}","id_vsl":"${this.vslId}"}`,
      }).then(response => { if (response.status == 200) { this.deletarAWSFinal(); this.listar() } })
    },
    deletarAWS(Thumb) {
      axios.request({ method: 'DELETE', url: `${this.VUE_APP_HOST_API_AWS_S3}/`, params: { key: Thumb, delete: '' } })
        .then(() => { this.listar() })
    },
    deletarAWSPausa(Thumb) {
      axios.request({ method: 'DELETE', url: `${this.VUE_APP_HOST_API_AWS_S3}/`, params: { key: Thumb, delete: '' } })
    },
    deletarAWSFinal(Thumb) {
      axios.request({ method: 'DELETE', url: `${this.VUE_APP_HOST_API_AWS_S3}/`, params: { key: Thumb, delete: '' } })
    },
    removerCallActionsVsl() {
      this.$store.state.callActions.allCallActions.forEach(() => {
        const divElement = document.querySelectorAll('.vslbooster-call-action')
        divElement.forEach(d => { if (d) d.remove() })
      })
    },
    createStyle(idVsl) {
      const styleHeader = document.createElement('style')
      styleHeader.type = 'text/css'
      styleHeader.id = `style_call_actions__${idVsl}`
      document.head.appendChild(styleHeader)
    },
    setStyleHeader(style) {
      const styleHeader = document.getElementById(`style_call_actions__${this.vslId}`)
      if (!styleHeader) return
      styleHeader.innerHTML += style
    },
    updateProgress() {
      const videoElement = this.$refs.mainVideo
      const progress = (videoElement.currentTime / videoElement.duration) * 100
      this.progress = progress.toFixed(2)
    },
    timeUpdatedVideo() {
      const time = this.$refs.mainVideo.currentTime
      this.updateProgress()
      this.$store.state.callActions.allCallActions.forEach(c => {
        if (c.start <= time && c.end >= time) {
          const divElement = document.getElementById(`vslbooster-call-action_${c.id}_2023`)
          if (divElement) divElement.classList.remove('vslbooster-call-action__hide')
        } else {
          const divElement = document.getElementById(`vslbooster-call-action_${c.id}_2023`)
          if (divElement) divElement.classList.add('vslbooster-call-action__hide')
        }
      })
    },
    carregarCallActionsVsl() {
      this.removerCallActionsVsl()
      this.$store.state.callActions.allCallActions.forEach(c => {
        const divElement = document.createElement('div')
        divElement.id = `vslbooster-call-action_${c.id}_2023`
        divElement.classList.add('vslbooster-call-action', `vslbooster-call-action__${c.position}`, `callaction_${c.id}_2`)
        divElement.style.zIndex = '1'
        if (c.start > 0) divElement.classList.add('vslbooster-call-action__hide')
        const linkElement = document.createElement('a')
        linkElement.href = c.link
        linkElement.target = '_blank'
        linkElement.classList.add('vslbooster-call-action-link', 'vslbooster-call-action-transfer-utm', `btn_callaction_${c.id}_2023`, `vslbooster-call-action__tranparencia_${c.transparencia_btn}`, `vslbooster-call-action__size_btn_${c.size}`)
        linkElement.title = c.text
        linkElement.textContent = c.text
        this.setStyleHeader(`
          .btn_callaction_${c.id}_2023 {
            background-color: ${c.background_color} !important;
            color: ${c.text_color} !important;
          }
          .btn_callaction_${c.id}_2023:hover {
            background-color: ${c.background_hover_color} !important;
          }
        `)
        divElement.appendChild(linkElement)
        const playerDiv = document.querySelector('#player-video-vsl')
        playerDiv.appendChild(divElement)
      })
    },
  },
}

</script>

<style lang="scss" scoped>
@import '@/assets/scssThumbnails/thumbInicio.scss';
@import '@/assets/scssThumbnails/thumbPausa.scss';
@import '@/assets/scssThumbnails/thumFinal.scss';

/* ===================== BA BRAND STYLES ===================== */
.ba-root {
  display: flex;
  flex-direction: row;
  min-height: calc(100vh - 80px);
  background: var(--dk-bg-segment, #F0F3F7);
  font-family: -apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', sans-serif;
  --dk-bg-segment:     rgba(255,255,255,0.04);
  --dk-bg-card:        rgba(255,255,255,0.05);
  --dk-bg-page:        rgba(255,255,255,0.04);
  --dk-bg-card-hover:  rgba(255,255,255,0.04);
  --dk-border:         rgba(255,255,255,0.09);
  --dk-border-light:   rgba(255,255,255,0.07);
  --dk-text-primary:   #e2e8f0;
  --dk-text-secondary: rgba(255,255,255,0.6);
  --dk-text-muted:     rgba(255,255,255,0.4);
  --dk-text-faint:     rgba(255,255,255,0.25);
}

/* Vertical layout (novo) */
.ba-root--vertical {
  flex-direction: column;
  padding: 24px;
  gap: 20px;
}
.ba-top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--dk-bg-card, #1a2535);
  border-radius: 14px;
  padding: 16px 24px;
  border: 1px solid var(--dk-border, rgba(255,255,255,0.06));
}
.ba-top-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}
.ba-player-section {
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
}
.ba-controls-section {
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* ── Sidebar (mantido para compat) ── */
.ba-sidebar {
  width: 308px;
  min-width: 300px;
  max-width: 320px;
  background: var(--dk-bg-card, #fff);
  border-right: 1px solid var(--dk-border, #E4EAF0);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  box-shadow: 2px 0 16px rgba(13,51,73,0.06);
}

/* Header */
.ba-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 22px 20px 18px;
  border-bottom: 1px solid var(--dk-border-light, #F0F3F7);
}
.ba-header-icon {
  width: 42px; height: 42px;
  border-radius: 12px;
  background: rgba(232,106,16,0.10);
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.ba-header-text { flex: 1; min-width: 0; }
.ba-header-title {
  font-size: 14px;
  font-weight: 700;
  color: var(--dk-text-primary, #0D3349);
  line-height: 1.2;
}
.ba-header-sub {
  font-size: 11px;
  color: var(--dk-text-muted, #94a3b8);
  margin-top: 2px;
}

/* Actions */
.ba-actions {
  display: flex;
  gap: 8px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--dk-border-light, #F0F3F7);
}
.ba-btn-save {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background: #E86A10 !important;
  background-image: none !important;
  color: #fff !important;
  border: none;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(232,106,16,0.30);
  transition: all 0.18s;
}
.ba-btn-save:hover {
  background: #c85a08 !important;
  box-shadow: 0 4px 16px rgba(232,106,16,0.40);
  transform: translateY(-1px);
}
.ba-btn-back {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background: var(--dk-bg-segment, #F4F6F9) !important;
  background-image: none !important;
  color: var(--dk-text-secondary, #64748b) !important;
  border: 1.5px solid var(--dk-border, #E4EAF0);
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none !important;
  transition: all 0.15s;
  white-space: nowrap;
}
.ba-btn-back:hover {
  background: rgba(255,255,255,0.08) !important;
  color: #e2e8f0 !important;
  text-decoration: none !important;
}
.ba-btn-back-full {
  flex: 1;
}

/* Body */
.ba-body {
  padding: 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

/* Adicionar botão */
.ba-btn-add {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  background: rgba(232,106,16,0.08) !important;
  background-image: none !important;
  border: 2px dashed #E86A10;
  border-radius: 12px;
  padding: 13px 16px;
  font-size: 13.5px;
  font-weight: 700;
  color: #E86A10;
  cursor: pointer;
  text-align: left;
  transition: all 0.18s;
  margin-bottom: 16px;
}
.ba-btn-add:hover {
  background: rgba(232,106,16,0.15) !important;
  border-color: #c85a08;
  color: #c85a08;
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(232,106,16,0.15);
}
.ba-btn-add-icon {
  width: 30px; height: 30px;
  border-radius: 8px;
  background: rgba(232,106,16,0.12);
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}

/* Section label */
.ba-section-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.09em;
  color: var(--dk-text-muted, #94a3b8);
  margin-bottom: 10px;
}

/* CTA list */
.ba-cta-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Empty state */
.ba-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  text-align: center;
  background: var(--dk-bg-card-hover, #FAFBFC);
  border: 1.5px dashed rgba(255,255,255,0.09);
  border-radius: 14px;
  gap: 10px;
}
.ba-empty-icon {
  width: 64px; height: 64px;
  border-radius: 50%;
  background: var(--dk-bg-segment, #F4F6F9);
  display: flex; align-items: center; justify-content: center;
}
.ba-empty-title {
  font-size: 13.5px;
  font-weight: 700;
  color: var(--dk-text-faint, #b0b9c7);
  margin: 0;
}
.ba-empty-sub {
  font-size: 12px;
  color: var(--dk-text-faint, #c0c8d4);
  line-height: 1.5;
}

/* ── Preview Area ── */
.ba-preview-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 32px 40px;
  background: var(--dk-bg-segment, #F0F3F7);
  min-width: 0;
}

/* Chrome bar */
.ba-preview-chrome {
  display: flex;
  align-items: center;
  gap: 10px;
  background: var(--dk-bg-card, #fff);
  border: 1.5px solid var(--dk-border, #E4EAF0);
  border-bottom: none;
  border-radius: 12px 12px 0 0;
  padding: 10px 16px;
}
.ba-chrome-dots { display: flex; gap: 6px; align-items: center; }
.ba-dot { width: 11px; height: 11px; border-radius: 50%; display: block; }
.ba-dot-red    { background: #ff5f57; }
.ba-dot-yellow { background: #febc2e; }
.ba-dot-green  { background: #28c840; }
.ba-chrome-title {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 11.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--dk-text-muted, #94a3b8);
  flex: 1;
}
.ba-live-pill {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: #16a34a;
  background: #dcfce7;
  padding: 3px 9px;
  border-radius: 20px;
}
.ba-live-dot {
  width: 7px; height: 7px;
  border-radius: 50%;
  background: #16a34a;
  animation: ba-pulse 1.4s ease-in-out infinite;
}
@keyframes ba-pulse {
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.3; }
}

/* Player wrapper */
.ba-player-wrap {
  flex: 1;
  background: #0a1520;
  border-radius: 0 0 12px 12px;
  overflow: hidden;
  border: 1.5px solid var(--dk-border, #E4EAF0);
  border-top: none;
  box-shadow: 0 12px 40px rgba(13,51,73,0.16);
}

/* ── Player internals (mantidos do original) ── */
.vslbooster-call-action {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  padding: 20px 20px 40px;
  transform: none;
  display: block;
  pointer-events: none;
}
.vslbooster-call-action.vslbooster-hide { display: none; }

.player {
  width: 100%;
  height: 500px;
  position: relative;
  overflow: hidden;
}
.player:fullscreen, .player:-webkit-full-screen, .player:-ms-full-screen, .player:-moz-full-screen {
  max-width: none; width: 100%;
}
.player_my_video {
  min-width: 102%;
  height: 500px;
}
.player_my_controls {
  display: flex;
  position: absolute;
  bottom: 0;
  width: 100%;
  transform: translateY(100%) translateY(-31%);
  transition: all .3s;
  flex-wrap: wrap;
  background: rgba(0,0,0,.2);
}
.player:hover .player_my_controls { transform: translateY(0); }
.player_my_controls > * { flex: 1; }
.progress {
  flex: 10;
  position: relative;
  display: flex;
  flex-basis: 100%;
  height: 10px;
  transition: height .3s;
  background: rgba(0,0,0,.25);
  cursor: pointer;
}
.progress_my_filled {
  width: 80%;
  background: rgba(255,226,40,.815);
  flex: 0;
  flex-basis: 0%;
}
.player_my_button {
  background: none;
  border: 0;
  line-height: 1;
  color: white;
  text-align: center;
  outline: 0;
  padding: 10px 15px;
  cursor: pointer;
  max-width: 50px;
}
.fullscreenbtn {
  background: none;
  border: 0;
  line-height: 1;
  outline: 0;
  padding: 10px 20px 20px 10px;
  cursor: pointer;
  max-width: 50px;
  position: absolute;
  right: 0;
}
.playpause {
  background-color: rgba(178,34,34,0);
  border-radius: 50px;
  background-repeat: no-repeat;
  width: 100%; height: 100%;
  position: absolute;
  left: 0; right: 0; top: 0; bottom: 0;
  margin: auto;
  background-size: contain;
  background-position: center;
  cursor: pointer;
  z-index: 10 !important;
  opacity: 1;
  transition: opacity 400ms;
}
.playpause[hidden] { opacity: 0; display: block; }
.playpausebg, .playEndedbg {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background-size: cover;
  background-position: center;
  z-index: 5;
}
.tooltip-progress {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 100;
  font-size: 12px;
  color: white;
  background: rgba(0,0,0,0.5);
  padding: 2px 8px;
  border-radius: 4px;
  pointer-events: none;
}
.iniciar {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  z-index: 20;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.vslbooster-controlls__hide { display: none !important; }
.loader {
  height: 70px;
  width: 200px;
  display: flex;
  align-items: center;
}
.loader .stroke {
  display: block;
  position: relative;
  background: var(--dk-bg-inset, #f1f1f1);
  height: 50%;
  width: 15%;
  border-radius: 50px;
  margin: 0 5px;
  animation: animate 1.2s linear infinite;
}
@keyframes animate {
  50% { height: 20%; }
  100% { height: 100%; }
}
.stroke:nth-child(1)  { animation-delay: 0s; }
.stroke:nth-child(2)  { animation-delay: 0.3s; }
.stroke:nth-child(3)  { animation-delay: 0.6s; }
.stroke:nth-child(4)  { animation-delay: 0.9s; }
.stroke:nth-child(5)  { animation-delay: 0.6s; }
.stroke:nth-child(6)  { animation-delay: 0s; }
.stroke:nth-child(7)  { animation-delay: 0.2s; }
.stroke:nth-child(8)  { animation-delay: 0.5s; }
.stroke:nth-child(9)  { animation-delay: 0.1s; }
.stroke:nth-child(10) { animation-delay: 0s; }
.stroke:nth-child(11) { animation-delay: 0.3s; }
.stroke:nth-child(12) { animation-delay: 0.6s; }
</style>
